import { render } from "./TvmColorSelection.vue?vue&type=template&id=525d7cb3&scoped=true"
import script from "./TvmColorSelection.js?vue&type=script&lang=js&external"
export * from "./TvmColorSelection.js?vue&type=script&lang=js&external"

import "./TvmColorSelection.vue?vue&type=style&index=0&id=525d7cb3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525d7cb3"]])

export default __exports__